/**
 * Resolves ambiguous pathnames to an unambiguous format.
 *
 * Currently only removes a single leading `/` and any trailing `/`s, leaving a relatively generic name,
 * in case we discover we need to expand these rules.
 */
export const normalizePathname = (pathname: string) => pathname.replace(/(?:^\/)|(?:\/+$)/g, "");
